import React from 'react';
import * as PropTypes from 'prop-types';
import I18n from 'i18n-js';

import InputField from 'components/form-field/input-field/input-field';
import { VALIDATE_MESSAGE } from 'constants/booking-constants';
import Unicode from 'common/utils/unicode';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
  isRequired: PropTypes.bool,
  isRequiredMessage: PropTypes.string,
  maxLength: PropTypes.number,
  maxLengthMessage: PropTypes.string,
  minLength: PropTypes.number,
  minLengthMessage: PropTypes.string,
  isSender: PropTypes.bool.isRequired,
};

const defaultProps = {
  isRequired: true,
  isRequiredMessage: undefined,
  maxLength: 50,
  maxLengthMessage: undefined,
  minLength: 1,
  minLengthMessage: undefined,
};

const preprocessName = val => {
  if (!val) {
    return val;
  }

  const trimmedValue = val.replace(/^\s+/, '');
  const nameRegex = new RegExp(`^[${Unicode.w} '"]+$`);
  if (nameRegex.test(trimmedValue)) {
    return trimmedValue;
  }

  const forbiddenRegex = new RegExp(`[^${Unicode.w} '"]`, 'g');
  return trimmedValue.replace(forbiddenRegex, '');
};

const NameField = props => {
  const {
    isRequired,
    isSender,
    isRequiredMessage = isSender
      ? I18n.t(VALIDATE_MESSAGE.REQUIRED_SENDER_NAME)
      : I18n.t(VALIDATE_MESSAGE.REQUIRED_RECEIVER_NAME),
    maxLength,
    maxLengthMessage = I18n.t(VALIDATE_MESSAGE.MAX_LENGTH_NAME, { maxLength }),
    minLength,
    minLengthMessage = I18n.t(VALIDATE_MESSAGE.MIN_LENGTH_NAME, { minLength }),
  } = props;

  const rules = [
    {
      // pattern include: letters of all languages,
      // space, single quote, double quote
      pattern: new RegExp(`^[${Unicode.w} '"]+$`),
      message: I18n.t(VALIDATE_MESSAGE.INVALID_NAME),
    },
  ];

  if (isRequired) {
    rules.push({
      required: true,
      message: isRequiredMessage,
    });
  }

  if (maxLength) {
    rules.push({
      max: maxLength,
      message: maxLengthMessage,
    });
  }

  if (minLength) {
    rules.push({
      min: true,
      message: minLengthMessage,
    });
  }

  return <InputField {...props} rules={rules} normalize={preprocessName} />;
};

NameField.propTypes = propTypes;
NameField.defaultProps = defaultProps;

export default NameField;
